<template>
	<div :class="{'has-error': mensagemErro}">
		<label> <span v-if="obrigatorio" class="no-print">*</span> {{ label }}: </label>
		<!-- <input class="form-control" type="datetime-local" :value="dataInput" @input="$emit('input', $event.target.value)" /> -->
		<date-picker
			class="datepicker-input form-control-datepicker"
			type="datetime"
			value-type="YYYY-MM-DD HH:mm"
			format="DD/MM/YYYY HH:mm"
			:value="value"
			@input="$emit('input', $event)"
		></date-picker>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},

		value: {
			type: String,
			required: false,
			default: ''
		},

		mensagemErro: {
			type: String,
			required: false,
			default: ''
		},

		obrigatorio: {
			type: Boolean,
			required: false,
			default: false
		}
	}
}
</script>
